const getAccessToken = () => window.localStorage.getItem('accessToken');
const setAccessToken = (token) => { token ? window.localStorage.setItem('accessToken', token) : window.localStorage.removeItem('accessToken'); };
const getActiveFinanceTab = () => window.localStorage.getItem('activeFinanceTab');
const setActiveFinanceTab = (activeTab) => { activeTab ? window.localStorage.setItem('activeFinanceTab', activeTab) : window.localStorage.removeItem('activeFinanceTab'); };
export { getAccessToken, setAccessToken, getActiveFinanceTab, setActiveFinanceTab };
